import { Box } from "@mui/material";

interface WorkerBadgeImageProps {
  imageUrl: string;
  alt?: string;
}

export function WorkerBadgeImage(props: WorkerBadgeImageProps) {
  const { imageUrl, alt = "Worker Badge" } = props;
  return (
    <Box
      sx={(theme) => ({
        position: "relative",
        width: 180,
        height: 180,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        "&::after": {
          content: '""',
          position: "absolute",
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          backgroundColor: `${theme.palette.primary.main}4D`,
          animation: "pulse 2s infinite",
          zIndex: 0,
        },
        "@keyframes pulse": {
          "0%": {
            transform: "scale(0.95)",
            boxShadow: `0 0 0 0 ${theme.palette.primary.main}B3`,
          },
          "70%": {
            transform: "scale(1.1)",
            boxShadow: `0 0 0 10px ${theme.palette.primary.main}00`,
          },
          "100%": {
            transform: "scale(0.95)",
            boxShadow: `0 0 0 0 ${theme.palette.primary.main}00`,
          },
        },
      })}
    >
      <Box
        sx={{
          width: 168,
          height: 168,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box
          component="img"
          src={imageUrl}
          alt={alt}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
    </Box>
  );
}
